import { Directive, HostBinding, ElementRef, AfterViewInit, Renderer2 } from '@angular/core';

@Directive({
    selector: '[inline]',
    standalone: false
})
export class MbFieldInlineDirective implements AfterViewInit {

  constructor(private eRef: ElementRef, private r2: Renderer2) { }

  ngAfterViewInit() {
    this.r2.addClass(this.eRef.nativeElement.firstChild, 'inline');
  }
}
